module.exports = __webpack_public_path__ + "guiding-principles-4.svg?0963abebb138ece11735e0acc0a5d023";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/guiding-principles-4.svg
// module id = 48
// module chunks = 0